import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showClose"];
import "core-js/modules/es6.object.assign.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Created by chief on 17/4/6.
 */
import YearPanel from "./rc-calendar/year/YearPanel";
import { KeyCode } from '../../wui-core/src'; // import zhCN from "./locale/zh_CN";

import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Picker from "./rc-calendar/Picker";
import InputGroup from '../../wui-input-group/src';
import Input from '../../wui-input/src';
import Icon from "../../wui-icon/src";
import classnames from 'classnames';
import moment from "moment";
import omit from 'omit.js';
import { prefix } from "../../wui-core/src/index.js";
import { getLangInfo } from "./lang-utils"; //去掉focus报错

Picker.prototype.componentDidUpdate = function () {};

var YearPicker = /*#__PURE__*/function (_Component) {
  _inherits(YearPicker, _Component);

  var _super = _createSuper(YearPicker);

  function YearPicker(_props, context) {
    var _this;

    _classCallCheck(this, YearPicker);

    _this = _super.call(this, _props, context);

    _defineProperty(_assertThisInitialized(_this), "initValue", function (props) {
      var value = props.value || props.defaultValue;

      if (value) {
        if (typeof value == 'string') {
          if (moment(value).isValid && moment(value).isValid()) {
            value = moment(value);
          } else {
            console.error('value is not in the correct format');
            value = '';
          }
        } else if (value.format && value.isValid && value.isValid()) {
          value = value;
        } else {
          console.error('value is not in the correct format');
          value = '';
        }
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      _this.setState({
        value: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "inputFocus", function () {
      var self = _assertThisInitialized(_this);

      var input = document.querySelector(".".concat(prefix, "-date-calendar-input"));

      if (input) {
        if (input.value) {
          input.select();
        } else {
          input.focus();
        }

        input.onkeydown = function (e) {
          if (e.keyCode == KeyCode.DELETE) {
            input.value = '';
            self.props.onChange && self.props.onChange('', '');
          } else if (e.keyCode == KeyCode.ESC) {
            self.setState({
              open: false
            });
            var v = self.state.value;
            self.props.onOpenChange && self.props.onOpenChange(false, v, v && v.format(self.props.format) || '');
            ReactDOM.findDOMNode(self.outInput).focus(); // 按esc时候焦点回到input输入框
          }
        };
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function (open) {
      var self = _assertThisInitialized(_this);

      _this.setState({
        open: open
      });

      if (open) {
        setTimeout(function () {
          self.inputFocus();
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      var props = _this.props;

      _this.setState({
        value: value && Object.assign(value, {
          _type: 'year'
        }) || value
      });

      props.onChange && props.onChange(value, value && value.format(props.format) || '');
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        showClose: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        showClose: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function (e) {
      e.stopPropagation();

      _this.setState({
        value: ''
      });

      _this.props.onChange && _this.props.onChange('', '');
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          format = _this$props.format,
          disabledYear = _this$props.disabledYear;
      var isDisabled = disabledYear && disabledYear(value);
      if (isDisabled) return;

      _this.setState({
        open: false
      });

      onSelect && onSelect(value, value ? value.format(format) : '');
      _this.outInput && ReactDOM.findDOMNode(_this.outInput).focus();
    });

    var langInfo = getLangInfo(_props.locale); //获取语言包信息

    _this.state = {
      langInfo: langInfo,
      type: "year",
      value: _this.initValue(_props),
      open: _props.open || false,
      showClose: false
    };
    return _this;
  }

  _createClass(YearPicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ("value" in nextProps) {
        this.setState({
          value: this.initValue(nextProps)
        });
      }

      if ("open" in nextProps) {
        this.setState({
          open: nextProps.open
        });
      }

      if ("renderIcon" in nextProps) {
        this.setState({
          renderIcon: nextProps.renderIcon
        });
      }

      if ("locale" in nextProps) {
        var langInfo = getLangInfo(nextProps.locale); //获取语言包信息

        this.setState({
          langInfo: langInfo
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var state = this.state;
      var props = this.props;

      var showClose = props.showClose,
          others = _objectWithoutProperties(props, _excluded);

      var value = state.value;
      var Calendar = /*#__PURE__*/React.createElement(YearPanel, _extends({
        prefixCls: "".concat(prefix, "-date-calendar-picker"),
        rootPrefixCls: "".concat(prefix, "-date-calendar")
      }, omit(props, ['disabledYear']), {
        focus: function focus() {},
        locale: state.langInfo.langMap,
        value: this.state.value,
        onSelect: this.onSelect,
        showDateInput: props.showDateInput
      }));
      var classes = classnames(props.className, "".concat(prefix, "-datepicker-container"));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes
      }, omit(others, ['inputReadOnly', 'closeIcon', 'renderIcon', 'disabled', 'format', 'locale', 'placeholder', 'showDateInput', 'className', 'allowClear', 'renderExtraFooter', 'autoTriggerChange', 'showTime', 'validatorFunc', 'inputTabKeyOpen', 'destroyOnClose', 'disabledYear'])), /*#__PURE__*/React.createElement(Picker, _extends({}, props, {
        onOpenChange: this.onOpenChange,
        animation: 'animation' in props ? props.animation : "slide-up",
        onChange: this.handleChange,
        calendar: Calendar // prefixCls={`${prefix}-date-calendar`}  // TODO 会导致生成pointer-event:none致使点击失效
        ,
        value: state.value,
        open: this.state.open
      }), function (_ref) {
        var value = _ref.value;
        return /*#__PURE__*/React.createElement(InputGroup, {
          simple: true,
          className: "".concat(prefix, "-datepicker-input-group"),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, /*#__PURE__*/React.createElement(Input, {
          ref: function ref(_ref2) {
            return _this2.outInput = _ref2;
          },
          placeholder: _this2.props.placeholder,
          className: _this2.props.className,
          disabled: props.disabled,
          readOnly: true,
          value: value && value.format(props.format) || ""
        }), showClose && _this2.state.value && _this2.state.showClose && !props.disabled ? /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: _this2.clear
        }, props.closeIcon()) : /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border"
        }, props.renderIcon()));
      }));
    }
  }]);

  return YearPicker;
}(Component);

YearPicker.defaultProps = {
  closeIcon: function closeIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-close-c"
    });
  },
  renderIcon: function renderIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-calendar"
    });
  },
  disabled: false,
  showClose: true,
  // locale:zhCN,
  locale: 'zh-cn',
  format: 'YYYY',
  showDateInput: true,
  inputReadOnly: false,
  validatorFunc: function validatorFunc() {
    return true;
  }
};
export default YearPicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/YearPicker.js